import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import FormError from 'src/core/gd-form/common/form-error/form-error';
import Input from 'core/gd-form/form-element/input/input';

import RadioGroup from "core/gd-components/gd-radio-group/gd-radio-group-ui5";
import ButtonSubmitDeprecated from "core/gd-form/common/btn-submit/btn-submit";

export default class NewViewTemplateSaveTypeNew extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        access: PropTypes.string,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        const isManager = gd.ac.check.company.isManager(gd.companyId);

        const initFormData = {
            name    : _.get(this.props, 'name', ''),
            access  : _.get(this.props, 'access', isManager ? 'public' : 'private')
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                name    : { type: 'input', validator: val => _.isNil(val) || val.trim() === '' ? 'No valid characters found' : true},
                access  : { type: 'select', isRequired: true}
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSelectAccess = (value) => {
        this.form.setFieldValue("access", value);
        this.forceUpdate();
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    }

    render() {
        const selectedOption = this.form.getValue("access");
        const isManager = gd.ac.check.company.isManager(gd.companyId);

        const options = [
            { value: 'public',     label: 'Public',    description: 'Visible to all users, can be modified by users with full access', disabled: !isManager},
            { value: 'private',    label: 'Private',   description: 'Visible to you only', iconRight: 'i5-lock-solid'}
        ];

        return (
            <React.Fragment>
                <div className="tbl">
                    <div className="row">
                        <div className="label">Name</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name" />
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                </div>

                <div className="tbl">
                    <div className="row">
                        <div className="label top">Access</div>
                        <div className="element available-options">
                            <RadioGroup items={options}
                                        value={selectedOption}
                                        onChange={this.onSelectAccess}/>
                        </div>
                    </div>
                </div>

                <div className="actions">
                    <ButtonSubmitDeprecated className="submit" form={this.form} label="Save"/>
                </div>
            </React.Fragment>
        )
    }
}